// creates a tile to show a movie
import React from 'react';
import {Button, Image, StyleSheet, Text, View} from 'react-native';
import {listContains, toggleListElement} from '../services/storage-service';

class MovieTile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      need_to_watch: false,
      watched: false
    }

    listContains('favoriteMovies', this.props.movie.id).then((contains) => {
      this.setState({need_to_watch: contains});
    });
    listContains('watchedMovies', this.props.movie.id).then((contains) => {
      this.setState({watched: contains});
    });
  }

  render() {
    const movie = this.props.movie;
    // text and buttons should not overflowing the container
    return (
        <View style={styles.container}>
          <Image
              source={{uri: `https://image.tmdb.org/t/p/w500${movie.poster_path}`}}
              style={styles.image}
          />
          <View style={styles.textContainer}>
            <Text style={styles.title}>{movie.title}</Text>
            <Text style={styles.description}>{movie.overview}</Text>
          </View>
          <View style={styles.buttonContainer}>
            <Button
                title="Need to watch"
                onPress={() => {
                  toggleListElement('favoriteMovies', movie.id).then((movies) => {
                    this.setState({need_to_watch: !this.state.need_to_watch});
                    if(this.props.updateFunction) {
                      this.props.updateFunction();
                    }
                  });
                }}
                color={this.state.need_to_watch ? 'green' : 'black'}
            />
            <Button
                title="Watched"
                onPress={() => {
                  toggleListElement('watchedMovies', movie.id).then((movies) => {
                    this.setState({watched: !this.state.watched});
                    if(this.props.updateFunction) {
                      this.props.updateFunction();
                    }
                  });
                }}
                color={this.state.watched ? 'green' : 'black'}
            />
          </View>
        </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'top',
    width: '80%',
    marginTop: 20,
    marginLeft: '10%',
    marginRight: '10%',
    border: '1px solid black'
  },
  image: {
    width: 200,
    height: 300,
    margin: 20
  },
  textContainer: {
    width: '80%'
  },
  title: {
    fontSize: 30,
    fontWeight: 'bold',
    margin: 20
  },
  description: {
    fontSize: 20,
    margin: 20,
    textAlign: 'justify',
    overflow: 'hidden'
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '80%',
    marginBottom: 20
  }
});

export default MovieTile;
